import React from "react";
//#region src/TableFiltersLine/useFiltersLine.tsx
const getDisplayedSort = (tableApi) => {
	if (!tableApi) return null;
	const sortedStates = tableApi.getColumnState()?.filter((state) => state.sort != null) ?? [];
	if (sortedStates.length === 0) return null;
	if (sortedStates.every((state) => {
		const initial = tableApi.getColumnDef(state.colId)?.initialSort;
		if (initial == null) return false;
		return state.sort === initial;
	})) return null;
	const columnState = sortedStates[0];
	const colDef = tableApi.getColumnDef(columnState?.colId ?? "");
	const columnKey = colDef?.colId ?? colDef?.field;
	if (!columnState?.sort || !columnKey) return null;
	return {
		column: columnKey,
		label: colDef?.headerName ?? columnKey,
		sort: columnState.sort
	};
};
const getTableItemFilter = (filter, colDef) => {
	if (typeof filter === "object" && filter) {
		const filterValues = colDef.filterParams?.filtersLineValueFormatter(filter);
		const columnKey = colDef.colId ?? colDef.field;
		if (filterValues && columnKey) return {
			label: colDef.headerName ?? columnKey,
			value: filterValues,
			filterModel: filter,
			column: columnKey
		};
	}
	return null;
};
const useFiltersLine = (tableApi) => {
	const [filterItems, setFilterItems] = React.useState([]);
	const [sort, setSort] = React.useState(null);
	React.useEffect(() => {
		const handleSortChange = () => {
			setSort(getDisplayedSort(tableApi));
		};
		const handleFilterChange = () => {
			const currentFilters = tableApi?.getFilterModel();
			if (!currentFilters) {
				setFilterItems([]);
				return;
			}
			const nextFilters = Object.entries(currentFilters).reduce((acc, [column, value]) => {
				const colDef = tableApi?.getColumnDef(column);
				if (!colDef) return acc;
				const filter = getTableItemFilter(value, colDef);
				if (filter) acc.push(filter);
				return acc;
			}, []);
			setFilterItems(nextFilters);
		};
		tableApi?.addEventListener("filterChanged", handleFilterChange);
		tableApi?.addEventListener("sortChanged", handleSortChange);
		handleFilterChange();
		handleSortChange();
		return () => {
			tableApi?.removeEventListener("filterChanged", handleFilterChange);
			tableApi?.removeEventListener("sortChanged", handleSortChange);
		};
	}, [tableApi]);
	const handleFiltersReset = () => {
		tableApi?.setFilterModel(null);
		tableApi?.resetColumnState();
		tableApi?.onFilterChanged();
		tableApi?.onSortChanged();
	};
	return {
		sort,
		filterItems,
		handleFiltersReset
	};
};
//#endregion
export { useFiltersLine };

//# sourceMappingURL=useFiltersLine.js.map